"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./translation"), exports);
var withTranslation_1 = require("./withTranslation");
Object.defineProperty(exports, "withTranslation", { enumerable: true, get: function () { return withTranslation_1.withTranslation; } });
//# sourceMappingURL=index.js.map